import React from "react";
import withRouter from "./withRouter";

const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div
        className="auth-page-wrapper"
        style={{ height: "100vh", overflow: "hidden", position: "relative", zIndex: 1 }}
      >
        <div className="auth-bg-fullscreen auth-one-bg" id="auth-particles" />

        {/* pass the children */}
        {children}

        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0 text-muted">
                    &copy; {new Date().getFullYear()} Subhosting.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
